export class Values {
  static roles: any;
  static state: any;
  static locationType: any;
  static common: any;
  static localization: any;
  static language: string;
  static location: string;

  static getLocalizationValue(
    key: string,
    defaultValue: string | null = null
  ): string {
    return (
      (Values.localization && Values.localization[key]) || defaultValue || key
    );
  }
}
